import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { eventApi } from '../../api';
import { EEventQueryKey, useEventStore } from '../../model';

export const useGetEvents = (sportEventIds: number[]) => {
  const addEvents = useEventStore(state => state.addEvents);

  const eventsQuery = useQuery({
    queryKey: [
      EEventQueryKey.EVENTS,
      sportEventIds,
    ],
    enabled: !!sportEventIds.length,
    queryFn: () => eventApi.getSportEvents({ sportEventIds })
  });

  useEffect(() => {
    if (eventsQuery.data?.items) {
      addEvents(eventsQuery.data.items);
    }
  }, [addEvents, eventsQuery.data]);

  return eventsQuery;
};
